import {z} from 'zod'

export const Language = z.object({
    id: z.number().int().min(1),
    name: z.string().min(1),
    iso_639_1: z.string()
})
export type Language = z.infer<typeof Language>
